// extracted by mini-css-extract-plugin
export default {"btn":"Cart_btn__SXQjK","headerTable":"Cart_headerTable__4rvLI","bodyTable":"Cart_bodyTable__evNEt","header":"Cart_header__Vr1tx"};